/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Cc_Position_Failed_ToastInputs */

const en_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to position events: ${i?.error}`)
};

const fr_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du positionnement des evenements : ${i?.error}`)
};

const de_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Positionieren der Ereignisse: ${i?.error}`)
};

const it_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile posizionare gli eventi: ${i?.error}`)
};

const ru_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось разместить события: ${i?.error}`)
};

const es_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron posicionar los eventos: ${i?.error}`)
};

const zh_cn2_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件定位失败：${i?.error}`)
};

const ja_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベントの配置に失敗しました: ${i?.error}`)
};

const hi_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`घटनाओं को स्थान देने में विफल: ${i?.error}`)
};

const pt_pt2_shortcut_keys_cc_position_failed_toast = /** @type {(inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao posicionar eventos: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to position events: {error}" |
*
* @param {Shortcut_Keys_Cc_Position_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_cc_position_failed_toast = /** @type {((inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Cc_Position_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "de") return de_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "it") return it_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "es") return es_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_cc_position_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_cc_position_failed_toast(inputs)
	return en_shortcut_keys_cc_position_failed_toast(inputs)
});